export const accountPermissionStatus = ['ACTIVE', 'DISABLED'] as const;
export const TAB_VALUES = ['group', 'individual'] as const;
